<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button
        (click)="dismiss()"
        class="close-btn ion-no-margin"
        [title]="'COMMON.LABELS.CLOSE' | translate"
        [attr.aria-label]="'COMMON.LABELS.CLOSE' | translate"
        data-cy="video-modal-close"
      >
        <svg-icon
          class="color--dark"
          key="close"
          size="xl"
        ></svg-icon>
      </ion-button>
    </ion-buttons>
    <ion-title
      class="text--base text--medium"
      role="heading"
      aria-level="1"
    >
      {{ props.title }}
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content [scrollY]="false">
  <video
    *ngIf="!unplayable"
    class="player"
    controls
    autoplay
    playsinline
    [src]="props.url"
    (error)="onError($event)"
    [attr.aria-label]="
      'COMPONENTS.MEDIA.PLAY_VIDEO' | translate: { title: props.title }
    "
    data-cy="video-modal-player"
  ></video>
  <div
    *ngIf="unplayable"
    class="status"
    data-cy="video-modal-unplayable"
  >
    <span>{{ "COMPONENTS.MEDIA.UNPLAYABLE" | translate }}</span>
    <ion-button
      fill="outline"
      color="light"
      [href]="props.url"
      target="_blank"
    >
      {{ "COMMON.LABELS.DOWNLOAD" | translate }}
    </ion-button>
  </div>
</ion-content>
